import { ArrowRight } from 'lucide-react';
import { useDemoModal } from '../demo-modal-context';

export function FinalCta() {
  const { open } = useDemoModal();
  return (
    <section className="relative isolate overflow-hidden bg-ink py-24 text-white md:py-32">
      <div className="absolute inset-0 dot-pattern opacity-20" aria-hidden />
      <div
        className="absolute inset-x-0 -top-32 h-[480px] bg-gradient-to-b from-primary/30 to-transparent"
        aria-hidden
      />

      <div className="container-page relative">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-3xl font-semibold tracking-tight md:text-5xl">
            Built for pharmacies that need to prove every delivery.
          </h2>
          <p className="mt-5 text-base leading-relaxed text-white/70 md:text-lg">
            Request a 30-minute demo. We'll walk through your specific pharmacy operation and show you
            exactly how LYN Rx fits.
          </p>
          <div className="mt-10 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
            <button
              type="button"
              onClick={open}
              className="inline-flex items-center justify-center gap-2 rounded-lg bg-white px-5 py-3 text-sm font-medium text-ink shadow-sm transition-colors hover:bg-white/90"
            >
              Request a demo
              <ArrowRight className="h-4 w-4" />
            </button>
            <a
              href="mailto:hello@lynrx.co"
              className="inline-flex items-center justify-center rounded-lg border border-white/20 px-5 py-3 text-sm font-medium text-white transition-colors hover:bg-white/10"
            >
              hello@lynrx.co
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
